import { z } from 'zod';
import { requiredString } from '../helpers';
export const Snapsheet_Update_Claim_1_ConfigValidator = z.object({
    connectionId: requiredString('Snapsheet connection is required'),
    claimReferenceNumber: requiredString('Claim reference number is required'),
    attributes: z.union([z.record(z.string(), z.unknown()), requiredString('Attributes are required')])
});
//# sourceMappingURL=snapsheet-update-claim-1.js.map